
































import _ from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { editFactory } from '@/main/pages';
import { openRouteAndReplace } from '@/main/router/routerPath';

import { MERGE, NAME, VOZIDLO_MERGE, MERGE_PROPS, VOZIDLO_MERGE_VALUES } from './constants';
import { store } from './store/merge';
import { mergeActions } from './store/types';

export default editFactory(VOZIDLO_MERGE, store).extend({
	data() {
		return {
			updateMergeTable: false,
			dependencies: {
				[MERGE]: MERGE,
				[VOZIDLO_MERGE_VALUES]: VOZIDLO_MERGE_VALUES,
			},
			mergeProps: MERGE_PROPS,
			tableKeysIndex: {
				LABEL_INDEX: 3,
				SOURCE_NAME_INDEX: 4,
				DUPLICATE_NAME_INDEX: 12,
				LABEL_NAME_INDEX: 2,
			},
		};
	},
	computed: {
		similarItems() : any {
			return this.parentUri && this.$store.state.pages[this.parentUri.split('/')[1]].dependentTables
				? this.$store.state.pages[this.parentUri.split('/')[1]].dependentTables.MergeVozidlo
				: null;
		},
	},
	watch: {
		async VozidloId(newVal, oldVal) {
			if (!oldVal) {
				await this.loadDependentTableData(newVal);
			}
		},
	},
	methods: {
		async updateKVZ(record: object) {
			if (this.props.fromVinSpzExit) {
				return openRouteAndReplace(NAME, PageMode.EDIT, { props: true, id: this.VozidloId!, destroy: 'no' });
			}
			return openRouteAndReplace(NAME, PageMode.EDIT, { props: true, id: this.VozidloId!, updateData: record, fromMerge: true, destroy: 'no' });
		},
		createKVZ(record: object) {
			return openRouteAndReplace(NAME, PageMode.CREATE, { props: true, updateData: record, fromMerge: true, destroy: 'no' });
		},
		async loadVozidlo(id: number) {
			if (this.VozidloId !== id) {
				this.VozidloId = id;
				await this.$store.dispatch(`${this.storeUri}/${mergeActions.GET_VOZIDLO}`, this.VozidloId);
			}
		},
		async loadDependentTableData(id: number) {
			this.updateMergeTable = false;
			this.VozidloId = id;
			if (!this.props.fromVinSpzExit) {
				await this.fetchTableData([MERGE]);
			} else if (this.VozidloId) {
				await this.fetchTableData([VOZIDLO_MERGE_VALUES]);
			}
			this.updateMergeTable = true;
		},
		async fetchTableData(tablesToFetch : string[]) {
			const dataPromises = (await (tablesToFetch || Object.values(this.dependencies))
				// TODO: JM replace this.$store.dispatch with this.tableData after base actions are typed.
				.map((dependency) => this.$store.dispatch(`${this.storeUri}/${dependency}_${'TABLE_DATA'}`,
					{ filter: _.get(this, `${dependency}Filter`) }))) as Promise<any>[];
			return Promise.all(dataPromises);
		},
		async loadData() {
			this.endLoading();
		},
	},
});
